export default "__VITE_ASSET__c8db4778__"